// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer-module--Footer--2UJjc","activeClassName":"Footer-module--activeClassName--3g1c6"};